import { BaseModel } from './BaseModel';

export class DueCardNotificationModel extends BaseModel {
    public deckId: string;
    public userId: string;
    public cardGuid: string;
    public due: any;
    public queued: boolean;
}
